import { configureStore,combineReducers } from "@reduxjs/toolkit";
import adminReducer from "./slices/adminSlice";
import adminAReducer from './slices/superAdminSlice';
import farmsReducer from './slices/farmsSlice';
import sFarmReducer from './slices/singleFarmSlice';
import pensReducer from './slices/pensSlice';
import listReducer from './slices/listDamSlice';
import cattleReducer from './slices/singleCattleSlice'
import sensorsReducer from './slices/allSensorSlice'
import singleSensorReducer from './slices/singleSensorSlice'
import singleCollectorReducer from './slices/singleCollectorSlice'
import collectorsReducer from './slices/collectorsSlice';
import warningSlice from "./slices/warningSlice";
import timeReducer from "./slices/timeSlice"
import commentsReducer from "./slices/commentsSlice"
import psReducer from "./slices/PensStatusSlice"






import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
  } from 'redux-persist'
  import storage from 'redux-persist/lib/storage';
  const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    whitelist:['adminA','sFarm','time','ps']
  }
  const AdminpersistConfig = {
    key: 'admin',
    storage,
    whitelist:['currentAdmin','currentTheme','isLogin','detailStatusList']
  }
  const adminpersistedReducer=persistReducer(AdminpersistConfig,adminReducer)

const rootReducer=combineReducers({
    admin:adminpersistedReducer,
    adminA:adminAReducer,
    sFarm:sFarmReducer,
    time:timeReducer,
    ps:psReducer
    
})
const p=persistReducer(persistConfig,rootReducer)

export const store =configureStore({
    reducer:{p
      ,pens:pensReducer,
      list:listReducer,
      cattle:cattleReducer,
      sensors:sensorsReducer,
      singleSensor:singleSensorReducer,
      singleCollector:singleCollectorReducer,
      collectors:collectorsReducer,
      comments:commentsReducer,
      warning:warningSlice,
      farms:farmsReducer,

    },
    middleware: (thunk) =>
    thunk({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})
 export let persistor = persistStore(store)